import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import normaliseTrailingSlash from 'util/misc/normalise-trailing-slash';
import imageAttributes from 'util/react/image-attributes';

function renderImage(image) {
    const { width, height, caption, ...attrs } = imageAttributes(image); // eslint-disable-line
    const isResponsive = !width;
    return (
        <figure style={{
            maxWidth: width || 'inherit',
        }} className={ classnames('cms-image', {
            'cms-image__is-responsive': isResponsive,
        })}>
            <img className="cms-image--element" {...attrs}/>
            {caption && <figcaption className="cms-image--caption">{caption}</figcaption>}
        </figure>
    );
}

export default function CmsImage({ image, link }) {
    if (link.to) {
        return (
            <Link className="u-reset" to={normaliseTrailingSlash(link.to)}>
                {renderImage(image)}
            </Link>
        );
    }

    return renderImage(image);
}

CmsImage.propTypes = {
    image: PropTypes.shape({
        src: PropTypes.object.isRequired,
        title: PropTypes.string,
        alt: PropTypes.string,
    }),
    link: PropTypes.object,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/image/index.js